import { ReactComponent as Burger } from "./burguer.svg"
import { ReactComponent as Close } from "./close.svg"
import { ReactComponent as LogoFull } from "./logo_full.svg"
import { ReactComponent as UserCircle } from "./user_circle.svg"
import { ReactComponent as Hidro } from "./hidro.svg"
import { ReactComponent as Structure } from "./structure.svg"
import { ReactComponent as Elevator } from "./elevator.svg"
import { ReactComponent as Garden } from "./garden.svg"
import { ReactComponent as Trash } from "./trash.svg"
import { ReactComponent as Lamp } from "./lamp.svg"
import { ReactComponent as Finger } from "./finger.svg"
import { ReactComponent as Fire } from "./fire.svg"
import { ReactComponent as Security } from "./security.svg"
import { ReactComponent as Copy } from "./copy.svg"
import { ReactComponent as Check } from "./cehck.svg"
import { ReactComponent as Calculator } from "./calc.svg"
import { ReactComponent as Whatsapp } from "./whatsapp.svg"
import { ReactComponent as Dropdown } from "./dropdown.svg"
import { ReactComponent as AiStars } from "./ai_stars.svg"

export const Icons = {
  Burger,
  Close,
  Hidro,
  Structure,
  Elevator,
  Garden,
  Trash,
  Lamp,
  Finger,
  Fire,
  Security,
  Copy,
  Check,
  Calculator,
  LogoFull,
  UserCircle,
  Whatsapp,
  Dropdown,
  AiStars
}
